import { NgModule } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';

import { MsalGuard } from '@azure/msal-angular';
import { LoginComponent } from './views/login/login.component';
import { ValidateRedirectLogin } from './registro/guards/validar-redirect';
import { ValidarLogin } from './registro/guards/validar-login';
import { RestorePasswordComponent } from './views/restore-password/restore-password.component';


export const routes: Routes = [
  {
    path:'login',
    component: LoginComponent
  },
  {
    path:'restorepassword',
    component: RestorePasswordComponent
  },
  {
    path: 'home',
    component: DefaultLayoutComponent,
    canActivate : [MsalGuard],   
    children: [
      {
        path: 'base',
        loadChildren: () => import('./views/base/base.module').then(m => m.BaseModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'registro',
        loadChildren: () => import('./registro/registro.module').then(m => m.RegistroModule)
      },
    ]
  },
  {
    path: 'inicio',
    component: DefaultLayoutComponent,
    canActivate : [ValidarLogin],   
    children: [
      {
        path: 'base',
        loadChildren: () => import('./views/base/base.module').then(m => m.BaseModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'registro',
        loadChildren: () => import('./registro/registro.module').then(m => m.RegistroModule)
      },
    ]
  },
  { 
    path: '**', 
    redirectTo: '', 
    pathMatch: 'full',
    canActivate: [ValidateRedirectLogin]
  }
 
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
